module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/email-8a5eb79e3c172b21d0d3b93b9171eda7.svg";